import React from 'react';
import Alert from 'components/alert/alert';

export default function ThemeSupportAlert(props) {
  return (
    <Alert type="warning" {...props}>
      <span>
        This storefront uses Swell's V1 hosting solution and is no longer
        supported.&nbsp;
        <a href="https://developers.swell.is/storefronts/storefront-migration-guide">
          Learn how to migrate
        </a>
      </span>
    </Alert>
  );
}
